import React, { useState } from 'react';

import { link } from '@aline/routes';
import { IconButton } from '@mui/material';
import { Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ConfirmationDialog } from 'src/components';
import { useDeleteReminder } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

export const useReminderFooterStyles = makeStyles()(theme => ({
  footer: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    position: 'sticky',
  },
}));

export function ReminderDetailsFooter({ reminderId }: { reminderId: UUID }) {
  const { classes } = useReminderFooterStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const { deleteReminder, loading: deletingReminder } = useDeleteReminder(reminderId);

  return (
    <>
      <div className={classes.footer}>
        <IconButton disabled={deletingReminder} size="large" onClick={() => setOpen(!open)}>
          <Trash2 size={22} />
        </IconButton>
      </div>
      <ConfirmationDialog
        message="Are you sure you want to delete this reminder? This action cannot be undone."
        open={open}
        title="Delete reminder?"
        onClickPrimary={async () => {
          const { data } = await deleteReminder();
          if (!data) return;

          navigate(link.RemindersIndex(), { replace: true });
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
